import { Box, Icon, useDisclosure, Tooltip } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useTracking from '../../../../../../../common/src/hooks/tracking/useTracking';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';
import ToolbarIconButton from '../small-toolbar/ToolbarIconButton';
import { useAskLaterQuestions } from './api/getAskLaterQuestion';
import AskLaterQuestionsModal from './AskLaterQuestionsModal';
import useAskLaterTree from './hooks/useAskLaterTree';
import NotificationNumberBadge from './NotificationNumberBadge';

const AskLaterQuestionsToolbarButton: React.FC = () => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();
  const { flowId } = useFlowsRouteParams();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { data, isSuccess } = useAskLaterQuestions();

  const { treeItems, isLoading } = useAskLaterTree(flowId!, data?.questions);

  const handleClick = () => {
    trackEvent('Opened the ask later in the flow');
    onOpen();
  };

  return (
    <Box pos="relative">
      <AskLaterQuestionsModal
        questionList={data?.questions}
        data={treeItems}
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isLoading}
        isRemoveEnabled
      />
      {isSuccess && data.questions.length > 0 && (
        <Box
          pos="absolute"
          top="0"
          right="0"
          transform="translate(25%,-50%)"
          zIndex={1}
        >
          <NotificationNumberBadge amount={data.questions.length} />
        </Box>
      )}

      <Tooltip
        label={t('FLOWS_COMPANY-SCAN_ASK-LATER_TOOLTIP')}
        placement="right"
        shouldWrapChildren
      >
        <ToolbarIconButton
          onClick={handleClick}
          aria-label="Show broker info"
          icon={
            <Icon name="GeneralOthersClock" color="secondary.300" boxSize="7" />
          }
        />
      </Tooltip>
    </Box>
  );
};

export default AskLaterQuestionsToolbarButton;
